module.exports = __webpack_public_path__ + "media/images/plans/wedding_compact/estimate_1-dcce76f75cd59152661957e53ce11b23.jpg";